<template>
  <div>
    <div class="wap1">
      <div class="wap1-content">
        <h1 class="title">{{ ourQuality.titleOne }}</h1>
        <p>{{ ourQuality.contentOne }}</p>
        <p>{{ ourQuality.contentTwo }}</p>
      </div>
    </div>
    <div class="wap2">
      <div class="ability1">
        <div class="img_cover">
          <img :src="pictureList[0]">
        </div>
        <div class="bg_content">
          <div class="content_right">
            <div class="content_details">
              <h2 class="title">{{ ourQuality.list[0].title }}</h2>
              <p v-html="$convertPxToRem(ourQuality.list[0].content)"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="ability2">
        <div class="bg_content">
          <div class="content_left">
            <div class="content_details">
              <h2 class="title">{{ ourQuality.list[1].title }}</h2>
              <p v-html="$convertPxToRem(ourQuality.list[1].content)"></p>
            </div>
          </div>
        </div>
        <div class="img_cover">
          <img :src="pictureList[1]">
        </div>
      </div>
      <div class="ability3">
        <div class="img_cover">
          <img :src="pictureList[2]">
        </div>
        <div class="bg_content">
          <div class="content_right">
            <div class="content_details">
              <h2 class="title">{{ ourQuality.list[2].title }}</h2>
              <p v-html="$convertPxToRem(ourQuality.list[2].content)"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { getConfigDataApi } from "@/utils/http.js"

export default {
  name: 'Quality',

  data() {
    return {
      commonData: {},
      pictureList: []
    }
  },

  computed: {
    ...mapGetters([
      'currentLang'
    ]),
    ourQuality() {
      return this.currentLang.config.aboutPage.ourQuality
    }
  },

  created() {
    this.fetchCommonData();
  },

  methods: {
    fetchCommonData() {
      getConfigDataApi().then(result => {
        if (result.code == 1) {
          this.commonData = result.data
          this.pictureList = result.data.quality_pictures
        }
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.wap1 {
  padding-top: 70px;
  padding-bottom: 70px;
  .wap1-content {
    width: 1000px;
    margin: 0 auto 0;
    text-align: center;
    .title {
      font-size: 30px;
      color: #333;
      font-weight: 500;
    }
    p {
      font-size: var(--text-size-bit-larger);
      color: #777;
      line-height: 1.8;
      margin-top: 40px;
      text-align: justify;
      text-align-last: center;
    }
  }
}
.wap2 {
  .ability1 {
    display: flex;
    height: 550px;
  }
  .ability2 {
    display: flex;
    height: 550px;
  }
  .ability3 {
    display: flex;
    height: 550px;
  }

  .img_cover {
    width: 50%;
    min-width: 600px;
  }

  .img_cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .bg_content {
    width: 50%;
    min-width: 600px;
    background: #f5f5f5;
    position: relative;
  }
  //文字内容在右侧时
  .content_right {
    left: 85px;
    width: 520px;
    height: 550px;
    display: table;
    position: absolute;
    .content_details {
      display: table-cell;
      vertical-align: middle;
    }
  }

  //文字内容在左侧时
  .content_left {
    right: 85px;
    width: 520px;
    height: 550px;
    display: table;
    position: absolute;
    .content_details {
      display: table-cell;
      vertical-align: middle;
    }
  }

  h2 {
    color: #003359;
    font-weight: 500;
    line-height: 28px;
    margin-bottom: 36px;
    font-size: 26px;
  }
  p {
    // font-size: 17px;
    font-size: var(--text-size-normal);
    color: #777;
    line-height: 1.8;
    text-align: justify;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/about/Quality.vue